import { Interaction, Ticket } from "@/@types/global";
import httpManager from "@/app/shared/utils/httpManager";

class TicketService {
  ticketsUrl = "/tickets";
  interactionsUrl = "/interactions";

  private getTicketInteractionsUrl(ticketId: number): string {
    return `${this.interactionsUrl}/ticket/${ticketId}`;
  }

  async getDetails(id: number): Promise<Ticket> {
    // if (!id) throw Error("No ticket id specified");

    const url = `${this.ticketsUrl}/${id}/`;
    const response = await httpManager.get(url);

    return response?.data;
  }

  async getInteractionsChannels(
    ticketId: number
  ): Promise<{ messages: Interaction[]; voice: Interaction[]; whatsapp_voice: Interaction[] }> {
    const url = `${this.getTicketInteractionsUrl(ticketId)}/channels/`;
    const response = await httpManager.get(url);

    return response?.data;
  }

  async getInteractionMessages(interactionId: number, isWorkspace: boolean = false) {
    const url = `${this.interactionsUrl}/${interactionId}/messages/?is_workspace=${isWorkspace}`;
    const response = await httpManager.get(url);

    return response?.data;
  }

  async getCallInteractionsByIdentifier(
    ticketId: number,
    identifier: string,
    channel_type: number
  ): Promise<Interaction[]> {
    const url = `${this.getTicketInteractionsUrl(ticketId)}/calls/?identifier=${identifier}&channel_type=${channel_type}`;
    const response = await httpManager.get(url);

    return response?.data;
  }

  async updateTicket(id: number, body: Partial<Ticket>): Promise<void> {
    if (!id) return;
    
    const url = `${this.ticketsUrl}/${id}/`;

    await httpManager.put(url, body);
  }
}

export const ticketService = new TicketService();
